export default "/images/d1e11c97538eea96013fd52a0f6c5e27.png";